import { ScrollLockContext } from 'contexts/ScrollLockContext'
import React from 'react'
import styled from 'styled-components'

export type HelpLayerProps = {
  isVisible: boolean
  top?: number
  children?: React.ReactNode
}

const LayerArea = styled.div<{ top?: number }>`
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: ${(props): number | string =>
    props.top ? `calc(100% - ${props.top}px)` : '100%'};
`

const GreyBack = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.32);
`

const ChildrenArea = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`

const HelpLayer = (props: HelpLayerProps): JSX.Element => {
  const { isVisible, top, children } = props
  const [scrollLock, setScrollLock] = React.useContext(ScrollLockContext)

  React.useEffect(() => {
    setScrollLock(isVisible)
  }, [isVisible, scrollLock, setScrollLock])

  return (
    <>
      {isVisible && (
        <LayerArea top={top}>
          <GreyBack />
          <ChildrenArea>{children}</ChildrenArea>
        </LayerArea>
      )}
    </>
  )
}

export default React.memo(HelpLayer)
